import { render, staticRenderFns } from "./buySuccess.vue?vue&type=template&id=24812c84&scoped=true"
import script from "./buySuccess.vue?vue&type=script&lang=js"
export * from "./buySuccess.vue?vue&type=script&lang=js"
import style0 from "./buySuccess.vue?vue&type=style&index=0&id=24812c84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24812c84",
  null
  
)

export default component.exports